var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcScanId = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1E64EC0E-4169-44DC-A68F-5D973FB51618") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "POC-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00.00.02-Onboarding",
    transform: "translate(-24.000000, -392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(24.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-hi",
    transform: "translate(0.000000, 238.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EBEBEB",
    fillRule: "nonzero",
    x: 4,
    y: 10,
    width: 40,
    height: 28,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.05,
    transform: "translate(23.957500, 26.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 L1,0 C0.44771525,0 0,0.44771525 0,1 C0,1.55228475 0.44771525,2 1,2 L15,2 C15.5522847,2 16,1.55228475 16,1 C16,0.44771525 15.5522847,0 15,0 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.06,
    transform: "translate(23.957500, 22.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 L1,0 C0.44771525,0 0,0.44771525 0,1 C0,1.55228475 0.44771525,2 1,2 L15,2 C15.5522847,2 16,1.55228475 16,1 C16,0.44771525 15.5522847,0 15,0 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.9575,18 L24.9575,18 C24.4052153,18 23.9575,18.4477153 23.9575,19 C23.9575,19.5522847 24.4052153,20 24.9575,20 L38.9575,20 C39.5097847,20 39.9575,19.5522847 39.9575,19 C39.9575,18.4477153 39.5097847,18 38.9575,18 Z",
    id: "Path",
    fill: "#E60000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9575,19.5 L38.9575,19.5 C39.4122892,19.4985232 39.8088045,19.1903507 39.9225,18.75 C39.9444482,18.8315678 39.9562044,18.9155409 39.9575,19 C39.9575,19.5522847 39.5097847,20 38.9575,20 L24.9575,20 C24.4052153,20 23.9575,19.5522847 23.9575,19 C23.9612381,18.915226 23.9755146,18.831247 24,18.75 C24.1129782,19.187671 24.5055085,19.4951359 24.9575,19.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9575,23.5 L38.9575,23.5 C39.4122892,23.4985232 39.8088045,23.1903507 39.9225,22.75 C39.9444482,22.8315678 39.9562044,22.9155409 39.9575,23 C39.9575,23.5522847 39.5097847,24 38.9575,24 L24.9575,24 C24.4052153,24 23.9575,23.5522847 23.9575,23 C23.9612381,22.915226 23.9755146,22.831247 24,22.75 C24.1129782,23.187671 24.5055085,23.4951359 24.9575,23.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9575,27.5 L38.9575,27.5 C39.4122892,27.4985232 39.8088045,27.1903507 39.9225,26.75 C39.9444482,26.8315678 39.9562044,26.9155409 39.9575,27 C39.9575,27.5522847 39.5097847,28 38.9575,28 L24.9575,28 C24.4052153,28 23.9575,27.5522847 23.9575,27 C23.9587956,26.9155409 23.9705518,26.8315678 23.9925,26.75 C24.1061955,27.1903507 24.5027108,27.4985232 24.9575,27.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8175,38 C7.13614104,37.9704159 6.47395126,37.7654729 5.895,37.405 L5.9075,37.3425 L6.0475,36.65 C6.97,31.965 9.185,28.4825 12.0475,26.92 C10.2810604,25.6827576 9.23526391,23.6565854 9.25,21.5 C9.25,17.9125 12.0775,15 15.5525,15 C19.0275,15 21.8425,17.9175 21.8425,21.5 C21.850767,23.6496419 20.806893,25.6673624 19.0475,26.9025 C21.9125,28.4625 24.1325,31.95 25.0475,36.6525 L25.2975,37.94 L25.2975,38.005 L23.2875,38.005 L7.8175,38 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.54,15.5 C18.925,15.5 21.6925,18.2675 21.835,21.7275 C21.835,21.6525 21.835,21.58 21.835,21.505 C21.835,17.9175 19.0075,15.005 15.5325,15.005 C12.0575,15.005 9.25,17.9175 9.25,21.5 C9.25,21.575 9.25,21.6475 9.25,21.7225 C9.385,18.2675 12.155,15.5 15.54,15.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4175,27.1275 C19.2975,27.225 19.1675,27.3175 19.0475,27.4075 C21.9125,28.9675 24.1325,32.455 25.0475,37.1575 L25.2175,38.01 L25.3175,38.01 L25.3175,37.945 L25.0675,36.6575 C24.1725,32.1575 22.1025,28.78 19.4175,27.1275 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0475,37.145 C6.97,32.46 9.185,28.9775 12.0475,27.415 C11.92,27.3275 11.7975,27.2325 11.6775,27.135 C9,28.79 6.9275,32.165 6.0525,36.635 L5.9125,37.3275 L5.9,37.39 L5.99,37.4425 L6.0475,37.145 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,37.5 L8,37.5 C5.790861,37.5 4,35.709139 4,33.5 L4,34 C4,36.209139 5.790861,38 8,38 L40,38 C42.209139,38 44,36.209139 44,34 L44,33.5 C44,35.709139 42.209139,37.5 40,37.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.06
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcScanId);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_scan_id.8beb7e78011150078d6187350f248fa2.svg";